import clsx from 'clsx'
import { Button, Grid, Icon, Popover } from 'gu-ui-kit'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Placeholder from 'modules/Finance/Wallets/subcomponents/WalletsList/subcomponents/Placeholder'
import PageHeader from 'components/PageHeader'
import styles from 'modules/Finance/Wallets/subcomponents/WalletsList/WalletsList.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { List } from './subcomponents/List'

const WalletsList = () => {
  const { t } = useTranslation()
  const listRef = useRef()
  const breakpoint = useBreakpoint()
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()
  const popoverState = usePopupState({
    variant: 'popover',
    id: 'wallets-list-popover',
    breakpoints: {
      0: {
        variant: 'bottomSheet',
        hasBackdrop: true,
        showLabel: true,
      },
      768: {
        variant: 'popover',
        hasBackdrop: false,
      },
    },
  })

  const { wallets: { data: wallets = [], loaded } = {} } = useSelector(
    (state) => state['finance/wallets'],
  )

  if (!loaded) {
    return <Placeholder className={styles['wallets-list-placeholder']} />
  }

  if (!wallets.length) {
    return null
  }

  return (
    <nav
      ref={listRef}
      className={clsx(styles['wallets-list'])}
    >
      <Grid
        alignItems={'center'}
        justifyContent={'between'}
        className={'margin-bottom-24'}
      >
        <PageHeader>{t('wallets::heading')}</PageHeader>
        {!breakpoint.lg && (
          <>
            <Button
              startIcon={<Icon name={'business-cards'} />}
              variant={'ghost'}
              link
              {...bindTrigger(popoverState)}
            >
              {t('common::buttons.all_wallets')}
            </Button>
            <Popover
              {...bindPopover(popoverState)}
              hasBackdrop
            >
              <List popover />
            </Popover>
          </>
        )}
      </Grid>
      <List />
    </nav>
  )
}

export default WalletsList

WalletsList.propTypes = {}
